document.addEventListener("DOMContentLoaded", () => {

  const popup = document.getElementById("promo-popup");
  const closeBtn = document.querySelector(".promo-popup__close");
  const copyBtn = document.getElementById("copy-code-btn");
  const code = document.getElementById("discount-code");
  const shopBtn = document.querySelector(".promo-popup__button");

  if (!popup) return;

  const STORAGE_KEY = "promo_popup_seen";
  const DAYS = 7;

  const lastSeen = localStorage.getItem(STORAGE_KEY);

  if (lastSeen) {
    const daysPassed =
      (Date.now() - Number(lastSeen)) / (1000 * 60 * 60 * 24);

    if (daysPassed < DAYS) {
      return;
    }
  }

  setTimeout(() => {
    popup.style.display = "flex";
  }, 5000);

  function closePopup() {
    popup.style.display = "none";
    localStorage.setItem(STORAGE_KEY, Date.now());
  }

  closeBtn.addEventListener("click", closePopup);

  popup.addEventListener("click", function (e) {
    if (e.target === popup || e.target.classList.contains("promo-popup__overlay")) {
      closePopup();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closePopup();
    }
  });

  copyBtn.addEventListener("click", () => {

    navigator.clipboard.writeText(code.innerText);

    copyBtn.textContent = "✓ Copied!";

    setTimeout(() => {
        copyBtn.textContent = "Copy code";
    }, 2000);

});
if (shopBtn) {
  shopBtn.addEventListener("click", function () {
    localStorage.setItem(STORAGE_KEY, Date.now());
  });
}

});